import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Divider,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
  Select,
  MenuItem,
  Grid
} from '@mui/material';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { Bert } from 'meteor/themeteorchef:bert';
import { Redirect } from 'react-router-dom';
import _, {
  assign,
  cloneDeep,
  filter,
  find,
  includes,
  isEmpty,
  isEqual,
  isNil,
  toNumber,
  without
} from 'lodash';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { renderButton, renderCheckBox, renderTextField } from '../MaterialMUIComponent';
import Layers from '../../../api/Layers/Layers';
import MapsCollection, { MAP_TYPES } from '../../../api/Maps/Maps';
import Styles from '../../../api/Styles/Styles';
import { isEsriUser } from '../../../api/Users/user-operations';
import * as layerOps from '../../../api/Layers/layer-operations';
import * as mapOps from '../../../api/Maps/map-operations';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import LayerGallerySearchContainer from '../../containers/LayerGallerySearchContainer';
import LayersSelectedList from '../../atoms/LayersSelectedList';
import Loading from '../LoadingIpsilum';
import {
  baseTemplate,
  baseTemplate1,
  baseTemplate2,
  baseTemplate3,
  templates
} from '../../../modules/layoutPlantilla';
import methodPromise from '../../../modules/method-promise-wrapper';
// import useTimeStore from '../ZustandProvider';
import Validation from '../../containers/Validation';
import MapsAdvancedModal from '../../atoms/MapsAdvancedModal';
import MapsConfigSharedModal from '../../atoms/MapsConfigSharedModal';

const { isAdvanced } = Meteor.settings.public;

class MapEditor extends Component {
  state = {
    areLayersOverlayed: mapOps.areLayersOverlayed(this.props.map),
    baseMapsTransparency: mapOps.getBaseMapsTransparency(this.props.map),
    baseMapsZoom: mapOps.getBaseMapsZoom(this.props.map),
    isAdvancedMap: mapOps.areFeature(this.props.map),
    layersTransparency: mapOps.getLayersTransparency(this.props.map),
    layersZoom: mapOps.getLayersZoom(this.props.map),
    settingsAdvancedMap: mapOps.getSettingsAdvancedMap(this.props.map),
    mapType: mapOps.getType(this.props.map),
    openModalAdvancedMap: false,
    openModalSharedConfig: false,
    pageToRestore: 1,
    selectedBaseMaps: mapOps.getBaseMaps(this.props.map),
    selectedLayers: mapOps.getLayers(this.props.map),
    sharedConfiguration: mapOps.getSharedConfiguration(this.props.map),
    visibility: mapOps.getLayersVisibility(this.props.map),
    showSelectedButtons: false,
    selectedButtons: {
      Attribution: mapOps.showAttributionButton(this.props.map),
      BaseMapSelector: mapOps.showBaseMapSelector(this.props.map),
      DrawControl: mapOps.showDrawControl(this.props.map),
      Home: mapOps.showHomeButton(this.props.map),
      LayerEditor: mapOps.showLayerEditor(this.props.map),
      LayerSelector: mapOps.showLayerSelector(this.props.map),
      Legend: mapOps.showLegend(this.props.map),
      MiniMap: mapOps.showMiniMap(this.props.map),
      PopupInformation: mapOps.showPopupInformation(this.props.map),
      QRCode: mapOps.showQRCode(this.props.map),
      Search: mapOps.showSearchButton(this.props.map),
      SideBySide: mapOps.showSideBySide(this.props.map),
      Scale: mapOps.showScale(this.props.map),
      Title: mapOps.showTitleButton(this.props.map),
      ViewHtml: mapOps.showViewHtml(this.props.map),
      Zoom: mapOps.showZoomButton(this.props.map)
    },
    description: mapOps.getDescription(this.props.map),
    name: mapOps.getName(this.props.map),
    imageURL: mapOps.getImageURL(this.props.map),
    pageURL: mapOps.getPageURL(this.props.map),
    project: mapOps.getProject(this.props.map),
    logoURL: mapOps.getLogoURL(this.props.map)
  };

  styleModal = {
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    left: '50%',
    p: 4,
    position: 'absolute',
    top: '50%',
    transform: 'translate-50%, -50%',
    width: 400
  };

  componentDidUpdate(prevProps) {
    this.updateSelectedLayers(prevProps);
  }

  componentDidCatch() {
    return <Redirect to="/maps" />;
  }

  savePage = pageNumber => {
    this.setState({ pageToRestore: pageNumber });
  };

  updateSelectedLayers = prevProps => {
    const { layers, loading } = this.props;

    const { layers: oldLayers } = prevProps;
    if (!loading && !isEqual(oldLayers, layers)) {
      const layersIds = _.map(layers, layer => layerOps.getId(layer));
      this.setState(prevState => {
        const newSelectedLayers = filter(prevState.selectedLayers, layer =>
          includes(layersIds, layer)
        );
        const newSelectedBaseMaps = filter(prevState.selectedBaseMaps, layer =>
          includes(layersIds, layer)
        );

        return { selectedLayers: newSelectedLayers, selectedBaseMaps: newSelectedBaseMaps };
      });
    }
  };

  selectLayer = layerId => {
    const { layers } = this.props;
    const { mapType, selectedLayers, visibility } = this.state;

    const layer = find(layers, ['_id', layerId]);
    if (
      MAP_TYPES.CESIUM === mapType &&
      !layerOps.isGeoJSONApiBased(layer) &&
      !layerOps.is3DMapsSubtypes(layer)
    ) {
      Bert.alert('Layer type not supported', 'danger');
      return;
    }

    const newSelectedLayers = includes(selectedLayers, layerId)
      ? without(selectedLayers, layerId)
      : [...selectedLayers, layerId];
    this.setState({ selectedLayers: newSelectedLayers });
    const newVisibility = newSelectedLayers.map(id => ({
      layer: id,
      value: true
    }));
    const updatedVisibility = visibility.filter(item => newSelectedLayers.includes(item.layer));
    newVisibility.forEach(newItem => {
      const exists = updatedVisibility.some(item => item.layer === newItem.layer);
      if (!exists) {
        updatedVisibility.push(newItem);
      }
    });
    this.setState({ visibility: updatedVisibility });
  };

  selectBaseMap = layerId => {
    const { layers } = this.props;
    const { mapType, selectedBaseMaps } = this.state;

    const layer = find(layers, ['_id', layerId]);
    if (MAP_TYPES.CESIUM === mapType && layerOps.isGeoJSONApiBased(layer)) {
      Bert.alert('Base Map type not supported', 'danger');
      return;
    }

    const newSelectedBaseMaps = includes(selectedBaseMaps, layerId)
      ? without(selectedBaseMaps, layerId)
      : [...selectedBaseMaps, layerId];
    this.setState({ selectedBaseMaps: newSelectedBaseMaps });
  };

  changeBaseMapsTransparency = (event, layer) => {
    const { baseMapsTransparency } = this.state;
    const value = toNumber(event.target.value);
    const newBaseMapsTransparency = cloneDeep(baseMapsTransparency);

    const baseMapTransparency = find(newBaseMapsTransparency, ['id', layerOps.getId(layer)]);
    if (!isNil(baseMapTransparency)) baseMapTransparency.value = value;
    else newBaseMapsTransparency.push({ id: layerOps.getId(layer), value });

    this.setState({ baseMapsTransparency: newBaseMapsTransparency });
  };

  changeLayersTransparency = (event, layer) => {
    const { layersTransparency } = this.state;
    const value = toNumber(event.target.value);
    const newLayersTransparency = cloneDeep(layersTransparency);

    const layerTransparency = find(newLayersTransparency, ['id', layerOps.getId(layer)]);
    if (!isNil(layerTransparency)) layerTransparency.value = value;
    else newLayersTransparency.push({ id: layerOps.getId(layer), value });

    this.setState({ layersTransparency: newLayersTransparency });
  };

  changeBaseMapsZoom = (value, layer, isMaxZoom = true) => {
    const { baseMapsZoom } = this.state;
    const newBaseMapsZoom = cloneDeep(baseMapsZoom);

    const zoom = isMaxZoom ? 'maxZoom' : 'minZoom';
    const otherZoom = isMaxZoom ? 'minZoom' : 'maxZoom';
    const otherZoomValue = isMaxZoom ? layerOps.getMinZoom(layer) : layerOps.getMaxZoom(layer);

    const baseMapZoom = find(newBaseMapsZoom, ['id', layerOps.getId(layer)]);
    if (!isNil(baseMapZoom)) {
      baseMapZoom[zoom] = toNumber(value);
    } else {
      newBaseMapsZoom.push({
        id: layerOps.getId(layer),
        [zoom]: toNumber(value),
        [otherZoom]: otherZoomValue
      });
    }

    this.setState({ baseMapsZoom: newBaseMapsZoom });
  };

  changeLayersZoom = (value, layer, isMaxZoom = true) => {
    const { layersZoom } = this.state;
    const newLayersZoom = cloneDeep(layersZoom);

    const zoom = isMaxZoom ? 'maxZoom' : 'minZoom';
    const otherZoom = isMaxZoom ? 'minZoom' : 'maxZoom';
    const otherZoomValue = isMaxZoom ? layerOps.getMinZoom(layer) : layerOps.getMaxZoom(layer);

    const layerZoom = find(newLayersZoom, ['id', layerOps.getId(layer)]);
    if (!isNil(layerZoom)) {
      layerZoom[zoom] = toNumber(value);
    } else {
      newLayersZoom.push({
        id: layerOps.getId(layer),
        [zoom]: toNumber(value),
        [otherZoom]: otherZoomValue
      });
    }

    this.setState({ layersZoom: newLayersZoom });
  };

  handleChangeTextField = (event, variable) => {
    this.setState({
      [variable]: event.target.value
    });
  };

  toggleVisibility = layerId => {
    this.setState(prevState => {
      const existingLayer = prevState.visibility.find(item => item.layer === layerId);
      let newSelectedBaseMaps;
      if (existingLayer) {
        newSelectedBaseMaps = prevState.visibility.map(item =>
          item.layer === layerId ? { ...item, value: !item.value } : item
        );
      } else {
        newSelectedBaseMaps = [...prevState.visibility, { layer: layerId, value: true }];
      }
      return { visibility: newSelectedBaseMaps };
    });
  };

  handleSubmit = async () => {
    const { map, isFree } = this.props;
    const {
      areLayersOverlayed,
      baseMapsTransparency,
      baseMapsZoom,
      description,
      imageURL,
      layersTransparency,
      layersZoom,
      logoURL,
      mapType,
      name,
      pageURL,
      project,
      selectedBaseMaps,
      selectedButtons,
      selectedLayers,
      settingsAdvancedMap,
      sharedConfiguration,
      visibility
    } = this.state;
    const existingMap = mapOps.getId(map);
    const methodToCall = existingMap ? 'maps.update' : 'maps.insert';

    const existingLayoutJson = () => {
      if (
        settingsAdvancedMap &&
        settingsAdvancedMap.buttonSettings &&
        settingsAdvancedMap.buttonSettings.templateDefault
      ) {
        if (settingsAdvancedMap.buttonSettings.templateDefault === 'baseTemplate') {
          return baseTemplate;
        }
        if (settingsAdvancedMap.buttonSettings.templateDefault === 'baseTemplate1') {
          return baseTemplate1;
        }
        if (settingsAdvancedMap.buttonSettings.templateDefault === 'baseTemplate3') {
          return baseTemplate3;
        }
        return baseTemplate2;
      }
      return baseTemplate2;
    };

    const textDescription = `El mapa ${name.trim()} está compuesto por dos tipos de capas. Las capas base se sitúan en el fondo y solo se puede seleccionar una de las siguientes. Por otro lado, las capas de superposición se puede elegir tanto el número como el orden de visualizacion.`;

    const newMap = {
      name,
      description: isEmpty(description) ? textDescription : description,
      mapType,
      layersOverlayed: areLayersOverlayed
    };

    if (mapType === MAP_TYPES.LEAFLET) {
      assign(newMap, {
        selectedButtons,
        sharedConfiguration,
        settingsAdvancedMap,
        imageUrl: isFree ? '' : imageURL,
        isFeature: areLayersOverlayed,
        logoUrl: isFree ? '' : logoURL,
        pageUrl: isFree ? '' : pageURL,
        project: isFree ? '' : project
      });
      if (areLayersOverlayed === true) {
        assign(newMap, {
          layoutJson: existingLayoutJson(),
          templates
        });
      }
    }
    if (isEmpty(selectedLayers) && isEmpty(selectedBaseMaps)) {
      Bert.alert('You need to choose at least one Base Map or one Layer', 'danger');
      return;
    }
    if (isEmpty(selectedBaseMaps) && MAP_TYPES.CESIUM === mapType) {
      Bert.alert('You need to choose at least one Base Map', 'danger');
      return;
    }

    newMap.layers = selectedLayers;
    newMap.baseMaps = selectedBaseMaps;
    newMap.baseMapsTransparency = baseMapsTransparency;
    newMap.baseMapsZoom = baseMapsZoom;
    newMap.layersTransparency = layersTransparency;
    newMap.layersZoom = layersZoom;
    newMap.settingsAdvancedMap = settingsAdvancedMap;
    newMap.visibility = visibility;

    if (existingMap) newMap._id = existingMap;

    try {
      const mapId = await methodPromise(methodToCall, newMap);
      this.redirectToMapView(existingMap, mapId);
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleAdvancedMap = () => {
    const { isAdvancedMap } = this.state;
    const { isFree } = this.props;
    if (!isFree) {
      this.setState({ isAdvancedMap: !isAdvancedMap });
    } else {
      Bert.alert('You need to upgrade your plan to use the advanced map feature', 'info');
    }
  };

  handleModalAdvancedMap = settings => {
    this.setState({ openModalAdvancedMap: false });
    this.setState({ settingsAdvancedMap: settings });
  };

  handleModalUserShared = settings => {
    this.setState({ openModalSharedConfig: false });
    this.setState({ sharedConfiguration: settings });
  };

  handleMapTypeSelector = event =>
    this.setState({
      mapType: event.target.value.trim(),
      // selectedLayers: [],
      // selectedBaseMaps: [],
      layersTransparency: [],
      baseMapsTransparency: [],
      baseMapsZoom: [],
      layersZoom: []
    });

  redirectToMapView(existingMap, mapId) {
    const { history } = this.props;
    const confirmation = existingMap ? 'Map updated!' : 'Map added!';
    Bert.alert(confirmation, 'success');
    history.push(`/maps/${mapId}`);
  }

  render() {
    const {
      deployEnv,
      isFree,
      layers,
      loading,
      map,
      styles,
      user,
      userControlSetting
    } = this.props;
    const {
      areLayersOverlayed,
      baseMapsTransparency,
      baseMapsZoom,
      description,
      imageURL,
      isAdvancedMap,
      layersTransparency,
      layersZoom,
      logoURL,
      mapType,
      name,
      pageURL,
      pageToRestore,
      project,
      selectedButtons,
      selectedLayers,
      selectedBaseMaps,
      showSelectedButtons,
      visibility
    } = this.state;

    const existingMap = mapOps.getId(map);
    const validationProps = {
      rules: {
        description: {
          required: false
        },
        imageUrl: {
          required: false
        },
        logoUrl: {
          required: false
        },
        mapType: {
          required: true
        },
        name: {
          required: true
        },
        pageUrl: {
          required: false
        }
      },
      messages: {
        mapType: {
          required: 'You need to choose a map type.'
        },
        name: {
          required: 'Need a name in here, Seuss.'
        }
      },
      submitHandler: () => {
        // if (!isFree && !isBasic) {
        this.handleSubmit();
        // } else if (isFree && unfilteredCount < deployConfig.Roles.Free.MapsLimit) {
        //   this.handleSubmit(form);
        // } else if (isBasic && unfilteredCount < deployConfig.Roles.Basic.MapsLimit) {
        //   this.handleSubmit(form);
        // } else {
        //   Bert.alert('You need to upgrade your plan to add more Layers', 'info');
        // }
      }
    };

    return (
      <Validation {...validationProps}>
        <Box component="form" onSubmit={event => event.preventDefault()}>
          {loading && <Loading />}
          {!loading && (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                {renderTextField({
                  label: 'Name',
                  key: 'name',
                  style: { width: '100%', marginTop: '2%' },
                  moreProps: {
                    onChange: event => this.handleChangeTextField(event, 'name'),
                    placeholder: "Oh, The Places You'll Go!",
                    value: name
                  }
                })}
                {renderTextField({
                  label: 'Descripción',
                  key: 'description',
                  style: { width: '100%', marginTop: '3%', marginBottom: '3%' },
                  moreProps: {
                    onChange: event => this.handleChangeTextField(event, 'description'),
                    placeholder:
                      "Congratulations! Today is your day. You're off to Great Places! You're off and away!",
                    value: description
                  }
                })}
                {isEsriUser(user) && (
                  <FormControl fullWidth margin="normal">
                    <Typography variant="body1" gutterBottom>
                      Tipo de Mapa
                    </Typography>
                    <Select
                      value={mapType}
                      onChange={this.changeMapType}
                      displayEmpty
                      inputProps={{ name: 'mapType' }}
                    >
                      <MenuItem value="ias">IAS Map</MenuItem>
                      <MenuItem value="esri">Esri WebMap</MenuItem>
                    </Select>
                  </FormControl>
                )}

                <FormControl
                  component="fieldset"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%'
                  }}
                >
                  <FormLabel>Map Type:</FormLabel>
                  <RadioGroup value={mapType} onChange={this.handleMapTypeSelector} row>
                    {_.map(MAP_TYPES.properties, item => {
                      return (
                        <FormControlLabel
                          key={item.name}
                          control={
                            <Radio sx={{ color: 'black', '&.Mui-checked': { color: '#2A3F90' } }} />
                          }
                          label={item.humanValue}
                          value={item.value}
                        />
                      );
                    })}
                  </RadioGroup>
                </FormControl>
                <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={1}>
                  {renderCheckBox({
                    normalName: 'Are Layers Overlayed',
                    onChange: () => this.setState({ areLayersOverlayed: !areLayersOverlayed }),
                    value: areLayersOverlayed
                  })}
                </Box>
                {mapType === MAP_TYPES.LEAFLET && isAdvanced && (
                  <>
                    <Box display="row" justifyContent="space-evenly" fullwidth="true">
                      {renderCheckBox({
                        disabled: isFree,
                        normalName: ' ',
                        onChange: this.handleAdvancedMap,
                        value: isAdvancedMap
                      })}
                      {isAdvancedMap === true ? (
                        <>
                          {renderButton({
                            disabled: isFree,
                            contentButton: 'Advanced Map',
                            onClick: () => this.setState({ openModalAdvancedMap: true })
                          })}
                        </>
                      ) : (
                        'Advanced Map'
                      )}
                      <MapsAdvancedModal
                        handleModalAdvancedMap={this.handleModalAdvancedMap}
                        {...this.state}
                        {...this.props}
                      />
                    </Box>
                  </>
                )}
                {mapType === MAP_TYPES.LEAFLET && (
                  <Grid container spacing={2} alignItems="center">
                    <Grid item>
                      {renderButton({
                        disabled: isFree,
                        contentButton: 'Configure shared maps',
                        onClick: () => this.setState({ openModalSharedConfig: true })
                      })}
                    </Grid>
                    <MapsConfigSharedModal
                      handleModalUserShared={this.handleModalUserShared}
                      {...this.state}
                      {...this.props}
                    />
                  </Grid>
                )}
                {mapType === MAP_TYPES.LEAFLET && (
                  <>
                    <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={1}>
                      <Box display="flex" alignItems="center" width="100%" mb={2}>
                        <IconButton
                          onClick={() => {
                            this.setState({ showSelectedButtons: !showSelectedButtons });
                          }}
                        >
                          {showSelectedButtons ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                        </IconButton>
                        <Typography variant="body1" sx={{ marginRight: 2 }}>
                          Map controls
                        </Typography>
                        <Divider
                          sx={{ flexGrow: 1, height: '0.5px', backgroundColor: 'grey', mr: 3 }}
                        />
                      </Box>
                      {showSelectedButtons === true && (
                        <>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'Atribución',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        Attribution: !selectedButtons.Attribution
                                      }
                                    }),
                                  value: selectedButtons.Attribution
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'Controles de Dibujo',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        DrawControl: !selectedButtons.DrawControl
                                      }
                                    }),
                                  value: selectedButtons.DrawControl
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  disabled: isFree,
                                  normalName: 'Editor de Capas',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        LayerEditor: !selectedButtons.LayerEditor
                                      }
                                    }),
                                  value: selectedButtons.LayerEditor
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'Home',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        Home: !selectedButtons.Home
                                      }
                                    }),
                                  value: selectedButtons.Home
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'Leyenda',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        Legend: !selectedButtons.Legend
                                      }
                                    }),
                                  value: selectedButtons.Legend
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'Mapa side by side',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        SideBySide: !selectedButtons.SideBySide
                                      }
                                    }),
                                  value: selectedButtons.SideBySide
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'MiniMap',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        MiniMap: !selectedButtons.MiniMap
                                      }
                                    }),
                                  value: selectedButtons.MiniMap
                                })}
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'Popup Información',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        PopupInformation: !selectedButtons.PopupInformation
                                      }
                                    }),
                                  value: selectedButtons.PopupInformation
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'QR Code',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        QRCode: !selectedButtons.QRCode
                                      }
                                    }),
                                  value: selectedButtons.QRCode
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'Selector Mapa Base',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        BaseMapSelector: !selectedButtons.BaseMapSelector
                                      }
                                    }),
                                  value: selectedButtons.BaseMapSelector
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  disabled: isFree,
                                  normalName: 'Selector de Capas',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        LayerSelector: !selectedButtons.LayerSelector
                                      }
                                    }),
                                  value: selectedButtons.LayerSelector
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'Search',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        Search: !selectedButtons.Search
                                      }
                                    }),
                                  value: selectedButtons.Search
                                })}
                              </Box>
                              <Box mb={1}>
                                {renderCheckBox({
                                  normalName: 'Zoom',
                                  onChange: () =>
                                    this.setState({
                                      selectedButtons: {
                                        ...selectedButtons,
                                        Zoom: !selectedButtons.Zoom
                                      }
                                    }),
                                  value: selectedButtons.Zoom
                                })}
                              </Box>
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </Box>

                    {!isFree && (
                      <>
                        {renderTextField({
                          label: 'Project',
                          key: 'project',
                          style: { width: '100%', marginTop: '3%' },
                          moreProps: {
                            onChange: event => this.handleChangeTextField(event, 'project'),
                            value: project
                          }
                        })}
                        {renderTextField({
                          label: 'Logo Imagen URL',
                          key: 'logoURL',
                          style: { width: '100%', marginTop: '3%' },
                          moreProps: {
                            onChange: event => this.handleChangeTextField(event, 'logoURL'),
                            value: logoURL,
                            placeholder: 'The image URL for the logo to show on the map'
                          }
                        })}
                        {renderTextField({
                          label: 'Web URL',
                          key: 'pageURL',
                          style: { width: '100%', marginTop: '3%' },
                          moreProps: {
                            onChange: event => this.handleChangeTextField(event, 'pageURL'),
                            value: pageURL,
                            placeholder: 'The web where the logo redirects'
                          }
                        })}
                        {renderTextField({
                          label: 'Imagen URL',
                          key: 'imageURL',
                          style: { width: '100%', marginTop: '3%', marginBottom: '3%' },
                          moreProps: {
                            onChange: event => this.handleChangeTextField(event, 'imageURL'),
                            value: imageURL,
                            placeholder: 'The image URL to use as thumbnail'
                          }
                        })}
                      </>
                    )}
                  </>
                )}
                <Button
                  variant="outlined"
                  color="success"
                  onClick={() => this.handleSubmit()}
                  sx={{
                    display: { xs: 'none', sm: 'inline-flex' },
                    marginTop: 2
                  }}
                >
                  {existingMap ? 'Save Changes' : 'Add Map'}
                </Button>
              </Grid>
              {mapType !== 'esri' && (
                <Grid item xs={12} sm={8}>
                  <LayerGallerySearchContainer
                    selectBaseMap={this.selectBaseMap}
                    selectLayer={this.selectLayer}
                    selectedLayers={selectedLayers}
                    selectedBaseMaps={selectedBaseMaps}
                    deployEnv={deployEnv}
                    pageToRestore={pageToRestore}
                    savePage={this.savePage}
                    mapType={mapType}
                    userControlSetting={userControlSetting}
                  />
                  <Grid container spacing={2} style={{ marginTop: '16px' }}>
                    <Grid item xs={12} sm={6}>
                      <LayersSelectedList
                        selectedLayers={selectedBaseMaps}
                        selectLayer={this.selectBaseMap}
                        changeTransparency={this.changeBaseMapsTransparency}
                        layersTransparency={baseMapsTransparency}
                        changeZoom={this.changeBaseMapsZoom}
                        layersZoom={baseMapsZoom}
                        layers={layers}
                        styles={styles}
                        listTitle="Base Maps"
                        emptyText="Add a base map"
                        visibility={visibility}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <LayersSelectedList
                        selectedLayers={selectedLayers}
                        selectLayer={this.selectLayer}
                        changeTransparency={this.changeLayersTransparency}
                        layersTransparency={layersTransparency}
                        changeZoom={this.changeLayersZoom}
                        layersZoom={layersZoom}
                        layers={layers}
                        styles={styles}
                        listTitle="Layers"
                        emptyText="Add a layer"
                        toggleVisibility={this.toggleVisibility}
                        visibility={visibility}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}
        </Box>
      </Validation>
    );
  }
}

MapEditor.defaultProps = {
  deployConfig: '',
  layers: [],
  map: {
    baseMaps: [],
    description: '',
    layers: [],
    layersOverlayed: true,
    mapType: MAP_TYPES.LEAFLET,
    name: '',
    selectedButtons: {
      Attribution: true,
      BaseMapSelector: true,
      DrawControl: true,
      Home: true,
      LayerEditor: false,
      LayerSelector: true,
      Legend: true,
      MiniMap: true,
      PopupInformation: false,
      Search: true,
      Scale: true,
      Title: true,
      ViewHtml: false,
      Zoom: true
    },
    settingsAdvancedMap: {}
  },
  user: {},
  styles: []
};

MapEditor.propTypes = {
  deployConfig: PropTypes.string,
  deployEnv: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  layers: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  isFree: PropTypes.bool.isRequired,
  isBasic: PropTypes.bool.isRequired,
  map: PropTypes.object,
  unfilteredCount: PropTypes.number.isRequired,
  match: PropTypes.object.isRequired,
  styles: PropTypes.array,
  user: PropTypes.object,
  userControlSetting: PropTypes.object.isRequired
};

export default withTracker(() => {
  const mapsSub = Meteor.subscribe('maps');
  const layersSub = Meteor.subscribe('layers');
  const stylesSub = Meteor.subscribe('styles');
  const userSub = Meteor.subscribe('users.editProfile');
  return {
    loading: !mapsSub.ready() || !userSub.ready() || !layersSub.ready() || !stylesSub.ready(),
    layers: Layers.find({ deleted: { $eq: 'no' } }).fetch(),
    styles: Styles.find({ deleted: { $eq: 'no' } }).fetch(),
    unfilteredCount: MapsCollection.find({ deleted: { $eq: 'no' } }).count(),
    user: Meteor.user()
  };
})(MapEditor);
